import React, { useCallback, useEffect, useRef } from 'react'
import cn from 'classnames'
import debounce from 'lodash/debounce'
import { useHistory } from 'react-router-dom'
import queryString from 'query-string'
import { useQueryParams } from '../../hooks/queryString'

export default function SearchFilter({ name = 'search', pageKey = 'page', ...attributes }) {
    const history = useHistory()
    const queryParams = useQueryParams()
    const inputRef = useRef(null)

    const [value, setValue] = React.useState(queryParams[name] || '')
    const queryParamsRef = useRef(queryParams)

    useEffect(() => {
        queryParamsRef.current = queryParams
    }, [queryParams])

    useEffect(() => {
        if (inputRef.current && inputRef.current.value) {
            inputRef.current.focus()
        }
    }, [])

    useEffect(() => {
        setValue(queryParams[name] || '')
    }, [queryParams[name]])

    const debouncedFunction = React.useMemo(() => debounce((val) => {
        const newParams = { ...queryParamsRef.current }
        if (val.trim() !== '') {
            newParams[name] = val.trim()
        } else {
            delete newParams[name]
        }
        const queryStringified = queryString.stringify({ ...newParams, [pageKey]: 1 })
        history.push(`?${queryStringified}`)
    }, 500), [history, name, pageKey])

    const onChange = (e) => {
        setValue(e.target.value)
        debouncedFunction(e.target.value)
    }

    return (
        <div style={{ flex: 'auto' }}
            className="control has-icons-left is-expanded"
        >
            <input
                ref={inputRef}
                type="search"
                value={value}
                onChange={onChange}
                className={cn('input')}
                placeholder="Поиск..."
                {...attributes}
            />
            <span className="icon is-small is-left">
                <i className="icon ion-md-search" />
            </span>
        </div>
    )
}
